import script from "./UiCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./UiCheckbox.vue?vue&type=style&index=0&id=ebd6f67c&scoped=true&lang=sass"

import exportComponent from "C:\\inetpub\\wwwroot\\agrii-carrier-prod\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebd6f67c"]])

export default __exports__